module.exports = __webpack_public_path__ + "media/images/details__prizeBox__event__second-669cd634c0466af82b6ef49dae16d596.png";